<template>
  <div class="stats-page">
    <el-card class="box-card">

      <!-- 搜索工具栏（参考老项目 hyxorder/order_stats.html） -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="投保人公司">
            <el-input v-model="searchForm.companyName" placeholder="投保人公司名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.mobile" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="渠道ID">
            <el-input v-model="searchForm.channelId" placeholder="渠道ID" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="sum-bar">
        <strong>充值总额：<span style="color: #ff7300">{{ sum | money }}</span> 元</strong>
      </div>

      <!-- 数据表格（充值统计字段） -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="company_name" label="公司名称" width="220" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="price_name" label="价格方案" width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="source_desc" label="来源" width="120" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="balance" label="余额(元)" width="120" align="right" :formatter="moneyFormat"></el-table-column>
        <el-table-column prop="pay_voucher_url" label="凭证" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_voucher_url || scope.row.voucher_url" class="link" @click="viewVoucher(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="trade_no" label="充值交易流水号" width="180" align="center"></el-table-column>
        <el-table-column prop="created_at" label="时间" width="180" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>

      <div style="text-align:right; margin-top: 10px;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[15, 20, 50]"
          :page-size="rows"
          :current-page="page"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from '@/lib/request'
import ExportJsonExcel from 'js-export-excel'
import { formatMoney as formatMoneyUtil, formatDate as formatDateUtil } from '@/utils/formatter'

export default {
  name: 'AppointmentFreightDepositStats',
  data() {
    return {
      loading: false,
      tableData: [],
      sum: 0,
      searchForm: {
        companyName: '', dateRange: [], mobile: '', channelId: ''
      },
      page: 1,
      rows: 15,
      total: 0
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    buildParams() {
      const params = { product_alias: 'hyx' }
      if (this.searchForm.companyName) params.company_name = this.searchForm.companyName
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
        params.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.channelId) params.channel_id = Number(this.searchForm.channelId)
      return params
    },
    async fetchData() {
      console.log(1111);
      
      this.loading = true
      try {
        const params = this.buildParams()
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/deposit/internal',
          method: 'get',
          params: { ...params, page: this.page, rows: this.rows },
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.tableData = res.rows || []
        this.total = Number(res.total || 0)
        await this.fetchSum(params)
      } catch (e) {
        console.error('获取充值统计失败', e)
      } finally {
        this.loading = false
      }
    },
    async fetchSum(params) {
      try {
        const res = await axios.request({
          url: '/v1/admin/cmn/transaction/deposit/sum',
          method: 'get',
          params,
          headers: { 'AppKey': 'BpLnfgDs' }
        })
        this.sum = Number(res.sum || 0) / 100
      } catch (e) {
        console.warn('拉取充值总额失败', e)
      }
    },
    handleSearch() { this.page = 1; this.fetchData() },
    handleReset() {
      this.searchForm = { companyName: '', dateRange: [], mobile: '', channelId: '' }
      this.page = 1
      this.rows = 15
      this.fetchData()
    },
    handleSizeChange(size) { this.rows = size; this.page = 1; this.fetchData() },
    handlePageChange(p) { this.page = p; this.fetchData() },
    handleExportExcel() {
      const data = this.tableData.map(r => ({
        '公司名称': r.company_name || '',
        '手机号': r.mobile || '',
        '价格方案': r.price_name || '',
        '来源': r.source_desc,
        '金额(元)': formatMoneyUtil(r.amount, ''),
        '余额(元)': formatMoneyUtil(r.balance, ''),
        '凭证': (r.pay_voucher_url || r.voucher_url) ? '有' : '无',
        '充值交易流水号': r.trade_no || '',
        '时间': this.formatDateDisplay(r.created_at)
      }))
      if (!data.length) {
        this.$message.warning('没有查询到数据')
        return
      }
      const option = {
        fileName: '预约货运险充值统计',
        datas: [{ sheetData: data, sheetName: 'sheet', sheetHeader: ['公司名称','手机号','价格方案','来源','金额(元)','余额(元)','凭证','充值交易流水号','时间'] }]
      }
      const toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    },
    // Element-UI 表格formatter签名 (row, column, cellValue)
    dateFormat(row, column, cellValue) {
      return this.formatDateDisplay(cellValue)
    },
    formatDateDisplay(value) {
      if (!value) return ''
      // 兼容：秒级时间戳 / 毫秒级时间戳 / 字符串日期
      let dateVal = value
      if (typeof value === 'number') {
        // 小于毫秒时间戳阈值则认为是秒，乘以1000；否则按毫秒处理
        dateVal = value < 2e12 ? value * 1000 : value
      }
      return formatDateUtil(dateVal, 'YYYY-MM-DD HH:mm:ss')
    },
    moneyFormat(row, column, cellValue) {
      if (cellValue == null) return ''
      // 统一使用项目金额格式化工具，去掉单位
      return formatMoneyUtil(cellValue, '')
    },
    viewVoucher(row) {
      const url = row.pay_voucher_url || row.voucher_url
      if (url) window.open(url, '_blank')
    },
    typeFormat(t) {
      if (t === 1) return '充值'
      if (t === 2) return '投保'
      if (t === 4) return '红包抵扣'
      if (t === 64) return '退款'
      return ''
    }
  },
  filters: { money(v) { return Number(v).toFixed(2) } }
}
</script>

<style scoped>
.search-toolbar { margin-bottom: 10px; }
.sum-bar { margin: 8px 0; }
</style>
